<template>
  <apartment-blank-form
    submit-label="Добавить квартиру"
    :apartment="apartment"
    :errors="errors"
    form-type="add"
    @submit="processApartmentForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { addApartment } from '@/services/apartment.service'
import apartmentBlankForm from '@/components/forms/apartment/ApartmentBlankForm'

export default {
  name: 'apartment-add-form',
  components: { apartmentBlankForm },
  props: {
    block: {
      type: [Number]
    }
  },
  data () {
    return {
      apartment: {
        id: null,
        number: '',
        block: this.block
      },

      errors: {
        apartment: {
          id: [],
          number: [],
          block: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processApartmentForm () {
      this.addApartment().then((success) => {
        if (success) {
          this.showMsg('Квартира была успешно добавлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    addApartment () {
      return addApartment(this.apartment).then((response) => {
        this.apartment = response.data
        this.fillErrors(this.errors.apartment, {})
        return true
      }).catch(err => {
        console.log(err.response)
        this.fillErrors(this.errors.apartment, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ApartmentAddForm.vue?383269e9